import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * SPM-3405: returns whether the Spark-chain thumbnail breadcrumbs should be shown.
 *
 * Defaults to `false` — the asset details page falls back to the route
 * loader's plain text breadcrumbs until the flag is explicitly enabled.
 */
function useShowSparkBreadcrumbs(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.SHOW_SPARK_BREADCRUMBS, false);
}

export { useShowSparkBreadcrumbs };
